export default {
  dataIterator: {
    rowsPerPageText: 'Stavaka po stranici:',
    rowsPerPageAll: 'Svi',
    pageText: '{0}-{1} od {2}',
    noResultsText: 'Nisu pronađeni odgovarajući zapisi',
    nextPage: 'Sljedeća stranica',
    prevPage: 'Prethodna stranica'
  },
  dataTable: {
    rowsPerPageText: 'Redova po stranici:'
  },
  noDataText: 'Nema dostupnih podataka',
  carousel: {
    prev: 'Prethodna slika',
    next: 'Sljedeća vizuala'
  }
}
